export const ISSUES_CREATE_PDF_REPORT_START = 'ISSUES_CREATE_PDF_REPORT_START';
export const ISSUES_CREATE_PDF_REPORT_API_REJECTED = 'ISSUES_CREATE_PDF_REPORT_API_REJECTED';
export const ISSUES_CREATE_PDF_REPORT_API_FULFILLED = 'ISSUES_CREATE_PDF_REPORT_API_FULFILLED';

export const createPdfReportStart = () => ({
  type: ISSUES_CREATE_PDF_REPORT_START,
});

export const createPdfReportSuccess = () => ({
  type: ISSUES_CREATE_PDF_REPORT_API_FULFILLED,
});

export const createPdfReportFailure = () => ({
  type: ISSUES_CREATE_PDF_REPORT_API_REJECTED,
});
